import type { PageVisibilityPort } from '@thom/folio-domain/core/ports/page-visibility'

const createPageVisibilityAdapter = (): PageVisibilityPort => ({
	visible: () => document.visibilityState === 'visible',

	onChange: listener => {
		document.addEventListener('visibilitychange', listener)

		return () => document.removeEventListener('visibilitychange', listener)
	},
})

export { createPageVisibilityAdapter }
